export default __webpack_public_path__ + "static/media/gallery_01.65f9dcb7.jpg";